import script from "./BaseModalHeaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModalHeaderComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModalHeaderComponent.vue?vue&type=style&index=0&id=83ccf350&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83ccf350"]])

export default __exports__